import { useOktaAuth } from '@okta/okta-react';
import { ComponentWithoutHOCProps } from 'common/types/component';
import { Loading } from 'common/utils/loading';
import { ReactElement, useEffect, useState } from 'react';
import { withAuthLayout } from '../login/authLayout.page';
import { CILogger } from 'common/log/log.provider';
import { OktaErrorDisplay } from './OktaErrorDisplay';

// Inspired by https://github.com/okta/okta-react/blob/master/src/LoginCallback.tsx
let handledRedirect = false;

const _OktaLoginCallback = (): ReactElement => {
    const { oktaAuth, authState } = useOktaAuth();
    const [callbackError, setCallbackError] = useState(null);

    useEffect(() => {
        // OKTA-635977: Prevents multiple calls of handleLoginRedirect() in React18 StrictMode
        // Top-level variable solution follows: https://react.dev/learn/you-might-not-need-an-effect#initializing-the-application
        if (!handledRedirect) {
            oktaAuth.handleRedirect('/sso/okta/postLogin').catch(async (e) => {
                if (oktaAuth?.isAuthenticated()) {
                    CILogger.getInstance().info(
                        'User signed out because visited okta postLogin page when already authenticated',
                        e
                    );

                    // TODO: error here should pass message to user + be aware signOut refreshes page and user can't see an error
                    await oktaAuth?.signOut();
                }

                setCallbackError(e);
            });
            handledRedirect = true;
        }
    }, [oktaAuth]);

    const authError = authState?.error;
    const displayError = callbackError || authError;

    const handleGoLoginPage = () => {
        window.location.href = '/';
    };

    if (displayError) {
        return <OktaErrorDisplay error={displayError} onGoToLogin={handleGoLoginPage} />;
    }

    return <Loading isLoading={true} />;
};

const OktaLoginCallback: ComponentWithoutHOCProps<null> = withAuthLayout(_OktaLoginCallback);

export default OktaLoginCallback;
